import React from "react";
import { Button, makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
    mobileKeyboard: {
        display: "none",
        "@media (max-width: 768px)": {
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "6px",
            padding: "8px",
            backgroundColor: tokens.colorNeutralBackground3,
            borderRadius: "8px",
            marginTop: "8px",
            width: "100%",
            boxSizing: "border-box",
        },
    },
    keyButton: {
        height: "45px",
        fontSize: "18px",
        fontWeight: "bold",
        padding: "0",
        minWidth: "0",
    },
    wideKeyButton: {
        gridColumn: "span 2",
    },
});

interface MobileKeyboardProps {
    onKeyPress: (key: string) => void;
    availableNumbers: Set<number>;
    isCompleted?: boolean;
}

export function MobileKeyboard({
    onKeyPress,
    availableNumbers,
    isCompleted,
}: MobileKeyboardProps) {
    const styles = useStyles();

    const getKeyDisplay = (key: string) => {
        if (key === "*") return "×";
        if (key === "/") return "÷";
        return key;
    };

    const renderKey = (key: string) => {
        const isNumber = !isNaN(Number(key));
        const isDisabled =
            isCompleted || (isNumber && !availableNumbers.has(Number(key)));
        return (
            <Button
                key={key}
                className={styles.keyButton}
                appearance="secondary"
                onClick={() => onKeyPress(key)}
                disabled={isDisabled}
            >
                {getKeyDisplay(key)}
            </Button>
        );
    };

    return (
        <div className={styles.mobileKeyboard}>
            {["7", "8", "9", "C"].map(renderKey)}
            {["4", "5", "6", "⌫"].map(renderKey)}
            {["1", "2", "3", "!"].map(renderKey)}
            {["(", "0", ")", "^"].map(renderKey)}
            {["+", "-", "*", "/"].map(renderKey)}
        </div>
    );
}
